<acl-ngx-page-header>
    <acl-ngx-page-header-section>
        <label>Market</label>
        <h4>{{ marketInfo?.name }}</h4>
    </acl-ngx-page-header-section>
    <acl-ngx-page-header-section *ngIf="userInfo?.userType === 'clientServices'">
        <auto-complete [fetchData]="autoCompletetConfig.marketAutoCompletePromise" width="500px" [buttonTrigger]="true"
            [responseMapper]="autoCompletetConfig.responseMapper"
            (onSelect)="autoCompletetConfig.handleOnMarketSelect($event)">
        </auto-complete>
    </acl-ngx-page-header-section>
</acl-ngx-page-header>
<div class="table-wrapper">
    <div>
        <acl-ngx-collapsible-nav>
            <acl-collapsible-nav-items-wrapper [collapsibleNavItems]="collapsibleItems">
            </acl-collapsible-nav-items-wrapper>
        </acl-ngx-collapsible-nav>
    </div>
    <div class="data-table">
        <advertiser-list [marketInfo]="marketInfo"></advertiser-list>
    </div>
</div>
